const font = "'DM Sans', system-ui, sans-serif";

export function LoadingSpinner({ message = 'Loading...' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '64px 0', fontFamily: font }}>
      <div style={{
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        border: '3px solid #252a38',
        borderTopColor: '#4f8ef7',
        animation: 'admin-spin 0.7s linear infinite',
      }} />
      <p style={{ color: '#64748b', fontSize: '14px', marginTop: '16px' }}>{message}</p>
      <style>{`@keyframes admin-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export function ErrorBanner({ error, onRetry }) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      background: 'rgba(248,113,113,0.1)',
      border: '1px solid rgba(248,113,113,0.3)',
      borderRadius: '8px',
      padding: '16px',
      fontFamily: font,
    }}>
      <span style={{ color: '#f87171', fontSize: '14px' }}>{error}</span>
      {onRetry && (
        <button onClick={onRetry} style={{
          marginLeft: '16px',
          flexShrink: 0,
          background: 'transparent',
          border: '1px solid rgba(248,113,113,0.4)',
          borderRadius: '6px',
          color: '#f87171',
          fontFamily: font,
          fontSize: '13px',
          fontWeight: '500',
          padding: '5px 12px',
          cursor: 'pointer',
        }}>
          Retry
        </button>
      )}
    </div>
  );
}

export function EmptyState({ message = 'No data found.' }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '64px 0', fontFamily: font }}>
      <p style={{ color: '#64748b', fontSize: '14px', margin: 0 }}>{message}</p>
    </div>
  );
}
